let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码, string (50), 必填</ownerCode>
    <items>
        <item>
            <itemId>仓储系统商品ID, string (50)</itemId>
            <itemCode>商品编码, string (50), 必填</itemCode>
        </item>
    </items>
</request>
`

let xmlResponse = `
<?xml version = "1.0" encoding = "utf-8" ?>
<response>
    <message>响应信息</message>
    <items>
        <item>
            <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
            <ownerCode>货主编码, string (50), 必填</ownerCode>
            <supplierCode>供应商编码, string (50)</supplierCode>
            <supplierName>供应商名称, string (200)</supplierName>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemName>商品名称, string (200)</itemName>
            <shortName>商品简称, string (200)</shortName>
            <englishName>商品英文名称, string (200)</englishName>
            <barCode>条形码 string (50)</barCode>
            <categoryName>商品类别名称, string (200)</categoryName>
            <title>商品标题, string (200)</title>
            <brandCode>品牌代码, string (50)</brandCode>
            <brandName>品牌名称, string (50)</brandName>
            <skuProperty>商品属性, string (200)</skuProperty>
            <length>长, double (18, 2)</length>
            <width>宽, double (18, 2)</width>
            <height>高, double (18, 2)</height>
            <volume>体积, double (18, 3)</volume>
            <grossWeight>毛重, double (18, 3)</grossWeight>
            <netWeight>净重, double (18, 3)</netWeight>
            <goodsCode>货号, string (50)</goodsCode>
            <color>颜色, string (50)</color>
            <year>年份, string (20)</year>
            <purchasePrice>价格, string (20)</purchasePrice>
            <size>尺寸, string (50)</size>
            <style>款式, string (50)</style>
            <itemType>商品类型, string (10), 例如: ZC=正常商品, FX=分销商品, ZH=组合商品, ZP=赠品, BC=包材, HC=耗材, FL=辅料, XN=虚拟品, FS=附属品, CC=残次品, OTHER=其它(只传英文编码), 必填</itemType>
            <stockUnit>单位, string (50)，例如：个、瓶、支</stockUnit>
            <shelfLife>保质期天数, double (18, 3)</shelfLife>
            <barCode1>条形码1 string (50)</barCode1>
            <barCode2>条形码2 string (50)</barCode2>
            <barCode3>条形码3 string (50)</barCode3>
            <barCode4>条形码4 string (50)</barCode4>
            <barCode5>条形码5 string (50)</barCode5>
            <customJson>自定义json</customJson>
            <extendProps>
                <key1>自定义字段1 (50)</key1>
                <key2>自定义字段2 (50)</key2>
                <key3>自定义字段3 (50)</key3>
                <key4>自定义字段4 (50)</key4>
                <key5>自定义字段5 (50)</key5>
            </extendProps>
        </item>
    </items>
    <flag>success|failure</flag>
    <code>响应码</code>
    </response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.singleitem.query.js